import normalItem from "./normalItem.vue";
export default {
  name: 'productList',
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    targetId: {
      default: ''
    },
    showTitle: {
      default: true
    },
    inPreview: {
      default: true
    }
  },
  components: {
    normalItem: normalItem
  },
  data: function data() {
    return {
      isInApp: window.mobileEnv == 'app' ? true : false,
      //是否App
      isTourist: window.mobileEnv == 'app' && window.isTourist ? true : false,
      //isTourist是否是游客
      isIOSReviewing: window.mobileEnv == 'app' && window.ykzApp.isIOSReviewing() ? true : false,
      //ykzApp.isIOSReviewing()是否送审状态
      productList: []
    };
  },
  watch: {
    list: function list() {
      this.initData();
    }
  },
  mounted: function mounted() {
    var targetTop = 0;
    this.initData();
    this.$nextTick(function () {
      if (this.targetId && String(this.targetId).indexOf("goods_") == 0 && $("#" + this.targetId).offset()) {
        targetTop = $("#" + this.targetId).offset().top;
      }
      this.$emit('totargetgoods', {
        from: "goods_",
        top: targetTop - $(window).height() * 0.2
      });
    });
  },
  methods: {
    toProductAddress: function toProductAddress(item) {
      this.$emit('todetail', $.extend(item, {
        saveItemId: "goods_" + item.goodsId
      }));
    },
    initData: function initData() {
      var that = this;
      that.productList = that.list;
    }
  }
};